import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { DateLong, money } from "utils/helpers";
import { PaymentTypeOptions } from "utils/Constant";

/**
 * Exports the Sales Order list to a PDF file.
 * @param {Array} listData - array of order rows (same shape as orderList?.data?.listData)
 * @param {Object} meta - { totalAmount, totalProfit, dateFrom, dateTo }
 */
export function exportSalesOrderToPdf(listData = [], meta = {}) {
    const { totalAmount = 0, totalProfit = 0, dateFrom, dateTo } = meta;

    const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "a4" });

    // Header
    doc.setFontSize(14);
    doc.text("Laporan Penjualan", 40, 40);

    doc.setFontSize(10);
    if (dateFrom && dateTo) {
        doc.text(`Periode: ${DateLong(dateFrom)} - ${DateLong(dateTo)}`, 40, 58);
    }

    const columns = [
        { header: "No", dataKey: "rowNumber" },
        { header: "Order Id", dataKey: "orderId" },
        { header: "Date", dataKey: "orderDate" },
        { header: "Payment Type", dataKey: "paymentType" },
        { header: "Total Items", dataKey: "totalItem" },
        { header: "Amount", dataKey: "nettAmount" },
        { header: "Profit", dataKey: "profit" },
        { header: "Status", dataKey: "status" },
    ];

    const rows = listData.map((row, i) => ({
        rowNumber: i + 1,
        orderId: row.orderId,
        orderDate: DateLong(row.orderDate),
        paymentType:
            PaymentTypeOptions.find((x) => x.value === String(row.paymentType))?.label ?? "-",
        totalItem: row.totalItem,
        nettAmount: `Rp ${money(row.nettAmount)}`,
        profit: `Rp ${money(row.profit)}`,
        status: row.status ? "Active" : "Inactive",
    }));

    autoTable(doc, {
        startY: 72,
        columns,
        body: rows,
        styles: { fontSize: 8, cellPadding: 4 },
        headStyles: { fillColor: [30, 30, 30], textColor: 255 },
        foot: [
            [
                { content: "Total", colSpan: 5, styles: { halign: "right", fontStyle: "bold" } },
                { content: `Rp ${money(String(totalAmount))}`, styles: { fontStyle: "bold" } },
                { content: `Rp ${money(String(totalProfit))}`, styles: { fontStyle: "bold" } },
                "",
            ],
        ],
        showFoot: "lastPage",
    });

    const fileName = `sales-order-${new Date().toISOString().slice(0, 10)}.pdf`;
    doc.save(fileName);
}